import { isValidElement, type ReactElement, type ReactNode } from 'react'

export const isRenderableSortValue = (value: unknown): value is ReactNode =>
  value == null ||
  typeof value === 'string' ||
  typeof value === 'number' ||
  typeof value === 'bigint' ||
  typeof value === 'boolean' ||
  isValidElement(value) ||
  (Array.isArray(value) && value.every(isRenderableSortValue))

export const containsReactElement = (
  value: unknown,
): value is ReactElement | ReactNode[] =>
  isValidElement(value) ||
  (Array.isArray(value) &&
    value.every(isRenderableSortValue) &&
    value.some(containsReactElement))
